import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginPage.vue')
  },
  {
    path: '/learning-path',
    name: 'LearningPath',
    component: () => import('@/views/LearningPath.vue')
  },
  {
    path: '/account',
    name: 'QuizProgress',
    component: () => import('@/views/Account.vue')
  },
  {
    path: '/lessons',
    name: 'QuizProgress',
    component: () => import('@/views/Lesson.vue')
  },
  {
    path: '/users',
    name: 'QuizProgress',
    component: () => import('@/views/Users.vue')
  },
  // temp route
  {
    path: '/quiz-edit/:slug',
    name: 'QuizEdit',
    component: () => import('@/views/QuizEdit.vue')
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: () => import('@/views/QuizList.vue')
  },
  {
    path: '/quiz/:slug',
    name: 'Quiz',
    component: () => import('@/views/Quiz.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log(store)
  console.log(store.state.auth)
  console.log(store.state)
  console.log(!store.state.auth.status.loggedIn)
  console.log(store.auth)
  if (!store.state.auth.status.loggedIn) {
    if (to.path === '/login' || to.path === '/register') {
      next();
    } else {
      next('/login')
    }
  } else {
    // can check token validation here & add loading
    if (to.path === '/login' || to.path === '/register') {
      next('/account');
    // } else if (to.path === '/lessons' || to.path === '/users') {
    //   if (store.state.auth.user.role === 'admin') {
    //     next('')
    //   } else {
    //     next('/account');
    //   }
    } else {
      next();
    }
  }
})

export default router
